export default "__VITE_ASSET__DhcGVN3e__"